"use strict";

import { AuthByRefreshToken } from 'api/rolesAPICall';
import { getStartArgs, resetQuery } from 'generics/queryArgs.js';

const TOKEN_KEY = ["MarketApp", "auth", "tokenPair"];

export function loadTokenTuple()  {
  const stored = utils_api.getStored( TOKEN_KEY );
  if ( stored && ("object" === typeof stored) )  {
    const { token=null, steamAppId=null, steamId=null } = stored;
    if ( !!token )
      return { token, steamAppId, steamId };
  }
  return null;
}


export function loadCookieTokenTuple()  {
  const token = $.cookie('yutoken');
  if ( !!token )
    return { token, };
  return null;
}


export function storeToken( token, steamAppId, steamId )  {
  utils_api.setStored( TOKEN_KEY, { token, steamAppId, steamId } );
  utils_api.sheduleReload();
}


export function resetToken( )  {
  utils_api.setStored( TOKEN_KEY, { token: null } );
}

export function detectOldInterface(modernUrl) {
  const interfaceOldVersion = utils_api.getStored(["MarketApp", "interfaceOldVersion"]);

  if (interfaceOldVersion === "false" && modernUrl !== undefined)
  {
    document.location.assign(modernUrl);
    return true;
  }

  return false;
}

export function detectSsoLanding()  {
  const { status }  =  getStartArgs();

  if ( status && ((+status) != 200) )
    return false;

  const { refresh_token }  =  getStartArgs();

  if ( refresh_token )
  {
    AuthByRefreshToken( refresh_token ).then((creds) => {
      const { jwt } = creds;

      if ( jwt )
      {
        const { app_id:steamAppId, steam_id:steamId }  =  getStartArgs();
        storeToken( jwt, steamAppId, steamId );
        resetQuery();
        return true;
      }
    });
  }

  return false;
}
